import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../context/AppContext";
import { X } from "lucide-react";

function timeLeft(endsAt) {
  const diff = new Date(endsAt).getTime() - Date.now();
  if (diff <= 0) return null;
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s };
}
const pad = n => String(n).padStart(2, "0");

export default function LaunchBanner() {
  const [sale, setSale] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("bl_sale_dismissed") === "1");
  const [left, setLeft] = useState(null);

  useEffect(() => {
    axios.get(`${API}/sale`).then(r => { if (r.data?.live) setSale(r.data); })
      .catch((err) => { console.warn("Sale endpoint unavailable:", err?.message || err); });
  }, []);
  useEffect(() => {
    if (!sale?.ends_at) return;
    const tick = () => setLeft(timeLeft(sale.ends_at));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [sale]);

  if (!sale || dismissed || !left) return null;

  const line = `◆ ${sale.label}  ·  ${sale.message.toUpperCase()}  ·  ENDS IN ${left.d}D ${pad(left.h)}H ${pad(left.m)}M ${pad(left.s)}S  ·  USE THE CART TO CHECKOUT`;
  const repeats = ["a", "b", "c", "d"];

  return (
    <div
      data-testid="launch-banner"
      className="fixed top-16 lg:top-20 left-0 right-0 z-[45] bg-[color:var(--bl-blue)] text-black overflow-hidden border-b border-black/10"
    >
      <div className="relative flex items-center h-9">
        <div className="flex-1 overflow-hidden">
          <div className="whitespace-nowrap flex gap-12 font-mono text-[11px] tracking-[0.25em] uppercase font-semibold bl-marquee">
            {repeats.map((k) => <span key={k} data-testid="launch-marquee-item">{line}</span>)}
          </div>
        </div>
        <button
          onClick={() => { sessionStorage.setItem("bl_sale_dismissed", "1"); setDismissed(true); }}
          aria-label="Dismiss"
          data-testid="launch-banner-dismiss"
          className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/10 hover:bg-black/25 p-1.5 transition-colors"
        ><X size={13} /></button>
      </div>
    </div>
  );
}
